import React from "react";
import LeftChevronIcon from "../../icons/leftChevronIcon";
import RightChevronIcon from "../../icons/rightChevronIcon";
import styles from "./style.module.css";

const DesktopPagination = ({ totalPages, selectedPage, handlePagination }) => {
  const renderPageNumbers = () => {
    const pages = [];

    // Always add first page
    pages.push(
      <button
        key={1}
        className={selectedPage === 1 ? styles.selected : ""}
        onClick={() => handlePagination(1)}
      >
        <span>1</span>
      </button>
    );

    // Add ellipsis after first page if needed
    if (selectedPage > 3) {
      pages.push(
        <span key="ellipsis1" className={styles.ellipsis}>
          ...
        </span>
      );
    }

    // Add pages around current page
    for (
      let i = Math.max(2, selectedPage - 1);
      i <= Math.min(totalPages - 1, selectedPage + 1);
      i++
    ) {
      if (i === 1 || i === totalPages) continue;
      pages.push(
        <button
          key={i}
          className={selectedPage === i ? styles.selected : ""}
          onClick={() => handlePagination(i)}
        >
          <span>{i}</span>
        </button>
      );
    }

    // Add ellipsis before last page if needed
    if (selectedPage < totalPages - 2) {
      pages.push(
        <span key="ellipsis2" className={styles.ellipsis}>
          ...
        </span>
      );
    }

    // Always add last page if there's more than one page
    if (totalPages > 1) {
      pages.push(
        <button
          key={totalPages}
          className={selectedPage === totalPages ? styles.selected : ""}
          onClick={() => handlePagination(totalPages)}
        >
          <span>{totalPages}</span>
        </button>
      );
    }

    return pages;
  };

  return (
    <div className={styles.pagination_container}>
      <button
        onClick={() => handlePagination(selectedPage - 1)}
        disabled={selectedPage === 1}
      >
        <LeftChevronIcon />
      </button>
      {renderPageNumbers()}
      <button
        onClick={() => handlePagination(selectedPage + 1)}
        disabled={selectedPage === totalPages}
      >
        <RightChevronIcon />
      </button>
    </div>
  );
};

export default DesktopPagination;
